module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "help-circle.9bda9467.png";